import { render, staticRenderFns } from "./stationTabButton.vue?vue&type=template&id=0ef463e0&"
import script from "./stationTabButton.vue?vue&type=script&lang=js&"
export * from "./stationTabButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports